import { getAliasesDocumentType, getMainDocumentTypeByCountry } from 'utilities/multiLanguageHelper';

export const getEuropeanUnionContries = (countries, documentType) => {
    const europeanUnionCountries = [];
    const mainDocumentType = getMainDocumentTypeByCountry();
    let country = {};

    countries.forEach(value => {
        country = value.toObject();

        if (country.europeanUnion) {
            if (__ORIGIN_COUNTRY__ === country.value) {
                if (documentType === mainDocumentType || documentType === getAliasesDocumentType(mainDocumentType)) {
                    return europeanUnionCountries.unshift(country);
                }
            }

            europeanUnionCountries.push(country.value);
        }
    });

    return europeanUnionCountries;
};
